import { areEquivalent } from '@/study-search/platform/array-extensions';
import { ParsedFilter } from './ParsedFilter';

export class ParsedFilters {
	public static areEqual(filters1: ParsedFilter[], filters2: ParsedFilter[]): boolean {
		if (filters1.length !== filters2.length) {
			return false;
		}

		const normalized1 = this.normalize(filters1);
		const normalized2 = this.normalize(filters2);
		return areEquivalent(normalized1, normalized2);
	}

	private static normalize(filters: ParsedFilter[]): string[] {
		return filters.flatMap((filter) =>
			filter.values.length === 0 ? filter.type : filter.values.map((value) => `${filter.type}-${value}`),
		);
	}
}
